'use client';

import { AutomationDayToggleGroup } from '../../automation/AutomaticExecutionsConfiguration';

type WeeklyDaysControlProps = {
  daysOfWeek: number[];
  disabled?: boolean;
  onSelectDay: (day: number) => void;
};

export const WeeklyDaysControl = ({
  daysOfWeek,
  disabled,
  onSelectDay,
}: WeeklyDaysControlProps) => (
  <AutomationDayToggleGroup
    daysOfWeek={daysOfWeek}
    disabled={disabled}
    onToggleDay={(day) => onSelectDay(day)}
  />
);
